export default __webpack_public_path__ + "static/media/20.d88fb67d.jpg";